import React from 'react';
import style from './style.module.css';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import api from '../../services/api';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { statusFunil } from '../../util/functions';
import useWrapper from '../../hooks/useWrapper';

const Board2 = props => {
  const navigate = useNavigate();
  const { board, setboard } = props;

  const { me, config } = useWrapper();

  return (
    <DragDropContext
      onDragEnd={ev => {
        (async () => {
          let _board = [...board];
          const _group_id = Number(ev.draggableId) || 0;
          const _step_source_index = ev.source?.droppableId - 1 || 0;
          const _step_destination_index = ev.destination?.droppableId - 1 || 0;

          if (_step_source_index !== _step_destination_index) {
            const _group = _board[_step_source_index].data.find(__group => __group.id === _group_id);
            if (!_group.has_budget && _step_destination_index >= 2) {
              toast.error('Para prosseguir com a ação é necessário a criação de um Orçamento');
            }
            else {
              _board[_step_destination_index].data.push(_group);
              _board[_step_source_index].data = _board[_step_source_index].data.filter(__group => __group.id !== _group_id);
              setboard(_board);
              try {
                const { data: _commercial } = await api.put(`commercial/${_group_id}`, { step_id: ev.destination.droppableId }, config);

                api.post('activity', {
                  message: `O status da negociação foi alterado para <b>${statusFunil(_commercial.step_id)}</b>`,
                  user_id: me.id,
                  commercial_id: _group_id,
                  type: 'act'
                }, config)

                console.log('_commercial', _commercial)
                toast.success('Status alterado com sucesso!');
              }
              catch (err) {
                toast.error('Falha ao salvar os dados.');
              }
            }
          }
        })()
      }}
    >
      <div className={style.board}>
        {board.map((__column, __column_i) => {
          const groups = __column.data.length || 0;
          const trainees = __column.data.reduce((__total, __group) => __total + __group.trainees, 0);
          const tasks_planned = __column.data.reduce((__total, __group) => __total + __group.tasks.planned, 0);
          const tasks_confirmed = __column.data.reduce((__total, __group) => __total + __group.tasks.confirmed, 0);
          const tasks_late = __column.data.reduce((__total, __group) => __total + __group.tasks.late, 0);
          return (
            <div className={style.column}>
              <p><b>{__column.label}</b></p>
              <p className='small-label'><b>{groups}</b> Turmas e <b>{trainees}</b> Formandos</p>
              <div className={style.tasks}>
                <div className={style.tasks_planned}>
                  <p>Tarefas Previstas <span>{tasks_planned}</span></p>
                </div>
                <div className={style.tasks_confirmed}>
                  <p>Tarefas Confirmadas <span>{tasks_confirmed}</span></p>
                </div>
                <div className={style.tasks_late}>
                  <p>Tarefas Atrasadas <span>{tasks_late}</span></p>
                </div>
              </div>
              <Droppable droppableId={__column.step_id}>
                {(provided) => (
                  <div className={style.groups} ref={provided.innerRef} {...provided.droppableProps}>
                    {__column.data.map((__group, __group_i) => (
                      <Draggable key={`group-${__group.id}`} draggableId={`${__group.id}`}>
                        {(provided) => (
                          <div
                            className={style.group}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            ref={provided.innerRef}
                            onClick={() => {
                              navigate(`/business/feed/${__group.id}`);
                            }}
                          >
                            <p><b>{__group.title}</b> {!!__group?.contract_number_legacy ? <span className='op-5 ml-1'>({__group.contract_number_legacy})</span> : ""}</p>
                            <p className='small-label'>{__group.institution}</p>
                            <div className={style.group_tasks}>
                              <span className={style.group_trainees}><span><b>{__group.trainees}</b> <span>Formandos</span></span></span>
                              <span className={style.group_tasks_planned}><b>{__group.tasks.planned}</b></span>
                              <span className={style.group_tasks_confirmed}><b>{__group.tasks.confirmed}</b></span>
                              <span className={style.group_tasks_late}><b>{__group.tasks.late}</b></span>
                            </div>
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </div>
          )
        })}
      </div>
    </DragDropContext>
  )
}

export default Board2;